import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,ViewController,AlertController,LoadingController,Events } from 'ionic-angular';

import { Webservice } from '../../providers/webservice'
import { Storagehelper } from '../../providers/storagehelper'


/**
 * Generated class for the Thoughtpopup page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-thoughtpopup',
  templateUrl: 'thoughtpopup.html',
})
export class Thoughtpopup {
	public thought;
  public loading;
  constructor(public navCtrl: NavController, public navParams: NavParams,public viewctrl:ViewController,public webservice:Webservice,public storage:Storagehelper,public alertCtrl:AlertController,public loader:LoadingController,public event:Events) {
  	
    this.thought={ThoughtID:0,Content:'',CreatedOn:'',Id:0,ServerId:0};

  	this.thought=this.navParams.get('thought');


    this.loading=this.loader.create({
      spinner:"ios",
      cssClass:"dreamLoader"
    });
  
  }
  ionViewWillEnter(){
    
    this.event.publish('app:changeHeaderBackground'); 
  }


  ionViewDidLoad() {
    console.log('ionViewDidLoad Thoughtpopup');
  }

  closeSettingsModal(){
  	this.viewctrl.dismiss();
  }

  saveThought(){
    this.loading.present();
  	var createdDate=this.thought.CreatedOn;

    var sendingThought={ThoughtID:undefined,Content:'',CreatedOn:'',Id:0,ServerId:0};
    sendingThought.ThoughtID=this.thought.ThoughtID;
    sendingThought.Content=this.thought.Content;
  	sendingThought.CreatedOn="";

  	sendingThought.Content=this.replaceAll(sendingThought.Content,' ','9a1');
  	this.webservice.saveThought(sendingThought).subscribe((data)=>{

  		if(data.Id!=undefined && data.Id>0)
	  		this.thought.Id=data.Id;
	  	this.thought.CreatedOn=createdDate;
      if(this.thought.ThoughtID!=undefined){
        this.storage.updateItem('thoughts','ThoughtID',this.thought.ThoughtID,this.thought).then(()=>{

          let alert=this.alertCtrl.create({
            title:"Mitt lugn",
            message:'Skickat',
            buttons:[{
              text:'OK',
              role:'cancel',
              handler:()=>{
                this.closeSettingsModal();
                this.loading.dismiss();
              }
            }]
          })
          alert.present();

        })
      }else{
        this.thought.CreatedOn=new Date();
        this.storage.addNewItem('thoughts','ThoughtID',this.thought).then((data)=>{
            this.thought.ThoughtID=data;
            let alert=this.alertCtrl.create({
              title:"Mitt lugn",
              message:'Skickat',
              buttons:[{
                text:'OK',
                role:'cancel',
                handler:()=>{
                  this.closeSettingsModal();
                  this.event.publish('app:thoughtSaved',{thoughtId:data});
                  this.loading.dismiss();
                }
              }]
            })
            alert.present();
        });


      }
	  	
		
  	},
  	err=>{

	  	this.thought.CreatedOn=createdDate;
  		this.thought.Content=this.replaceAll(this.thought.Content,'%20',' ');
  		this.closeSettingsModal();

      this.loading.dismiss();
  	});

  }

  replaceAll(string,search, replacement){
		var target = string;
    	return target.replace(new RegExp(search, 'g'), replacement);
  }


}



// WEBPACK FOOTER //
// ./src/pages/thoughtpopup/thoughtpopup.ts